<div
	[hidden]="!(show || forceShow)"
	class="modal-mask animated fadeIn"
	style="background-color: rgba(0, 0, 0, 0.6); z-index: 99999"
>
	<div
		class="modal-loading"
		style="
			width: auto;
			height: auto;
			padding: 30px 50px 20px;
			background-color: rgb(255, 255, 255);
			border-radius: 12px;
			top: calc(100% - 60%);
			left: calc(50% - 93px);
		"
	>
		<div class="loading-animate" style="width: 40px; height: 40px">
			<div class="animate-origin"><span style="width: 5px; height: 5px; background-color: rgb(0, 68, 138)"></span></div>
			<div class="animate-origin"><span style="width: 5px; height: 5px; background-color: rgb(0, 68, 138)"></span></div>
			<div class="animate-origin"><span style="width: 5px; height: 5px; background-color: rgb(0, 68, 138)"></span></div>
			<div class="animate-origin"><span style="width: 5px; height: 5px; background-color: rgb(0, 68, 138)"></span></div>
			<div class="animate-origin"><span style="width: 5px; height: 5px; background-color: rgb(0, 68, 138)"></span></div>
		</div>
		<p class="loading-discription" style="color: rgb(0, 68, 138); font-size: 14px">Cargando...</p>
	</div>
</div>
